// Libs
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendToast } from 'screens/Dashboard/actions';
import { openMergedReportPdf } from 'services/privateReportDownload';
// Components
import {
	// Icons
	LogoIcon,
	RefreshIcon,
	OpenInNewIcon,
	Wrapper,
} from 'components';
// Hooks
import useApi from '../Utils';

const RegenerateMergedPDFReports = ({
	resourceId,
	typeMergeButton,
	isLoading,
	setLoading,
}) => {
	const { onMergePDFReports, onMergeContractPdfReports } = useApi();

	const onMerge = {
		serviceMergedReports: onMergePDFReports,
		contractMergedReports: onMergeContractPdfReports,
	};
	// Handlers
	const handleOnClick = () => {
		setLoading(true);
		onMerge[typeMergeButton](resourceId)
			.then(() => setLoading(false))
			.catch(() => setLoading(false));
	};

	return (
		<Wrapper padding='0' onClick={handleOnClick}>
			<RefreshIcon onlyIcon />
			{isLoading && <LogoIcon spin />}
		</Wrapper>
	);
};

const ViewMergedPDFReports = ({ resourceId, typeMergeButton }) => {
	const dispatch = useDispatch(),
		current = useRef(null),
		mounted = useRef(true);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		mounted.current = true;
		return () => {
			mounted.current = false;
			if (current.current) current.current.cancel();
		};
	}, []);
	const open = async () => {
		if (current.current && current.current.pending) return;
		setLoading(true);
		try {
			current.current = openMergedReportPdf({
				otdId: resourceId,
				kind: typeMergeButton === 'contractMergedReports' ? 'site' : 'service',
			});
			await current.current.done;
		} catch (_) {
			if (mounted.current)
				dispatch(
					sendToast({
						type: 'error',
						message:
							'No se pudo abrir el PDF. Compruebe su sesión y vuelva a intentarlo.',
					}),
				);
		} finally {
			if (mounted.current) setLoading(false);
		}
	};
	return (
		<Wrapper padding='0' height='100%' onClick={open}>
			{loading ? <LogoIcon spin /> : <OpenInNewIcon selected />}
		</Wrapper>
	);
};

export { RegenerateMergedPDFReports, ViewMergedPDFReports };
